const range = (from: number, to: number): readonly number[] =>
    Array.from({ length: (to - from) / 100 + 1 }, (_, i) => from + i * 100);

/** The weights each built-in font really has on Google Fonts (measured
 *  2026-10-07). The loader and the typography weight menu both read them. */
export const BUILT_IN_FONT_WEIGHTS: Readonly<
    Record<string, readonly number[]>
> = {
    Rubik: range(300, 900),
    Arimo: range(400, 700),
    Assistant: range(200, 800),
    "Frank Ruhl Libre": range(300, 900),
    Fredoka: range(300, 700),
    Handjet: range(100, 900),
    Heebo: range(100, 900),
    "IBM Plex Sans Hebrew": range(100, 700),
    "Noto Rashi Hebrew": range(100, 900),
    "Noto Serif Hebrew": range(100, 900),
    "Open Sans": range(300, 800),
};

/** Each entry is a CSS font-family string — display label and value are the same. */
export const BUILT_IN_FONTS: readonly string[] = Object.keys(
    BUILT_IN_FONT_WEIGHTS
);

export const FALLBACK_TITLES_FONT = "Rubik";
export const FALLBACK_BODY_FONT = "Rubik";
